module.exports = __webpack_public_path__ + "img/image-dt.6db29009.png";